import { CircularProgress } from "@mui/material";
import Modal from "components/modal/Modal";

import CallFlowDetail from "./call-flow-detail/CallFlowDetail";

const CallFlowDetailModal = ({ open, onClose, currentItem, mode, loading }) => {
  let title = "";
  if (mode === "view") title = "Xem chi tiết luồng cuộc gọi";
  if (mode === "edit") title = "Chỉnh sửa luồng cuộc gọi";
  if (mode === "create") title = "Tạo mới luồng cuộc gọi";

  return (
    <Modal open={open} title={title} onClose={onClose} fullScreen>
      {loading && <CircularProgress size={35} />}
      {!loading && (
        <CallFlowDetail
          currentItem={currentItem}
          onSuccess={onClose}
          mode={mode}
        />
      )}
    </Modal>
  );
};

export default CallFlowDetailModal;
